import React from "react";

const EmailSuggestionButton = ({ email, onClick }) => {
    if (!email) return null;

    return (
        <button
            type="button"
            onClick={onClick}
            className="mt-2 aku-label-medium inline-flex max-w-full items-center rounded-full bg-[#EBE4FF] px-3 py-1 text-[#6F00FF] transition-colors hover:bg-[#E9DCFF] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#6F00FF] focus-visible:ring-offset-2"
        >
            <span className="truncate">Click to use “{email}”</span>
        </button>
    );
};

export default EmailSuggestionButton;
